@use '../../../../../app/styles/common/colors';
@use '../../../../../app/styles/common/mixins';

.deliveryBanner {
  position: relative;
  width: 120px;
  height: 170px;
  padding: 12px;
  background: colors.$greyBack url('https://file.birbir.uz/web/frontend/offer_delivery_banner.webp')
    0 100% no-repeat;
  background-size: 100px;
  border-radius: 16px;
  user-select: none;
  cursor: pointer;

  @include mixins.tablet {
    width: 204px;
    height: 244px;
    background-size: 152px;
  }

  @include mixins.laptop {
    width: 160px;
    height: 220px;
    background-size: 120px;
  }

  @include mixins.desktop {
    width: 180px;
    background-size: 132px;
  }
}

.label {
  width: 90%;
  margin-bottom: 8px;
  font-size: 16px;
  font-weight: 400;
  line-height: 20px;
}

.badge {
  display: inline-block;
  padding: 2px 10px;
  border-radius: 0 12px;
  background: colors.$bgSuccess;
  color: colors.$white;
  font-size: 12px;
  line-height: 16px;
  white-space: nowrap;
}

.button {
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  padding: 4px;
  bottom: 12px;
  right: 12px;
  background: colors.$white;
  border-radius: 50%;
}
